import { useTranslation } from "react-i18next";
import { UserPlus } from "lucide-react";

import { Button } from "@/components/ui/button";

import { PlanResourceIcon } from "./PlanResourceIcon";

interface PlanActionsProps {
  /** Omitted when the plan meters no seats. */
  onUpgradeSeats?: () => void;
  onBuyTokens: () => void;
}

/** Buying tokens is the primary path; seats sit beside it as the secondary. */
export const PlanActions = ({
  onUpgradeSeats,
  onBuyTokens,
}: PlanActionsProps) => {
  const { t } = useTranslation(["common", "company"]);

  return (
    <div className="flex gap-2">
      {onUpgradeSeats && (
        <Button
          variant="outline"
          size="sm"
          className="h-9 flex-1 font-semibold"
          onClick={onUpgradeSeats}
        >
          <UserPlus size={13} />
          {t("company:employees.upgrade_seats")}
        </Button>
      )}
      <Button
        variant="primary"
        size="sm"
        className="h-9 flex-1 font-semibold"
        onClick={onBuyTokens}
      >
        <PlanResourceIcon resource="tokens" size={16} />
        {t("company:subscription.buy_tokens")}
      </Button>
    </div>
  );
};
